export const getKeyByValue = <T>(obj: T, value: T[keyof T]): string => {
    const keys = Object.keys(obj as any) as Array<keyof T>;
    const key = keys.find(key => obj[key] === value);
    return key ? (key as any).toLocaleLowerCase() : '';
}